import React from "react";
import PropTypes from "prop-types";
import { StandardInput } from "src/react/forms/input";
import { AddressList } from "./address-list";

function AddressLookupUI({
  addressList,
  searchTerm,
  findAddress,
  retrieveAddress,
  onSearchAddress,
  triggerManualEntry,
  onFocus,
}) {
  return (
    <div>
      <StandardInput
        value={searchTerm}
        onChange={onSearchAddress}
        label="postcode or address"
        placeholder="Start typing your postcode or address"
        onFocus={onFocus}
      />
      {addressList && addressList.length > 0 && (
        <AddressList
          addressList={addressList}
          retrieveAddress={retrieveAddress}
          findAddress={findAddress}
          searchTerm={searchTerm}
          triggerManualEntry={triggerManualEntry}
        />
      )}
    </div>
  );
}

export default AddressLookupUI;

AddressLookupUI.propTypes = {
  addressList: PropTypes.array,
  searchTerm: PropTypes.string,
  findAddress: PropTypes.func,
  retrieveAddress: PropTypes.func,
  onSearchAddress: PropTypes.func,
  triggerManualEntry: PropTypes.func,
  onFocus: PropTypes.func,
};
